import ReactMarkdown from "react-markdown";

function Markdown({ children }) {
  return <ReactMarkdown children={children} />;
}

export default Markdown;
